import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeIntegerBaseComponent } from './e5core-ui-work-field-type-integer-base';

@Component({
  selector: 'e5core-ui-work-field-type-integer-material',
  templateUrl: './e5core-ui-work-field-type-integer-material.component.html',
  styleUrls: ['./e5core-ui-work-field-type-integer-material.component.css']
})
export class E5coreUiWorkFieldTypeIntegerMaterialComponent extends E5coreUiWorkFieldTypeIntegerBaseComponent {
}
